import React, { createContext, useContext, useState, useCallback } from 'react';

const VersionUpdateContext = createContext(null);

/**
 * Version Update Context Provider
 * Manages the state for version update notifications
 */
export const VersionUpdateProvider = ({ children }) => {
  const [hasNewVersion, setHasNewVersion] = useState(false);

  const notifyNewVersion = useCallback(() => {
    setHasNewVersion(true);
  }, []);

  const dismissNotification = useCallback(() => {
    setHasNewVersion(false);
  }, []);

  const refreshPage = useCallback(() => {
    window.location.reload();
  }, []);

  return (
    <VersionUpdateContext.Provider
      value={{
        hasNewVersion,
        notifyNewVersion,
        dismissNotification,
        refreshPage,
      }}
    >
      {children}
    </VersionUpdateContext.Provider>
  );
};

/**
 * Hook to access version update context
 */
export const useVersionUpdate = () => {
  const context = useContext(VersionUpdateContext);
  if (!context) {
    throw new Error('useVersionUpdate must be used within VersionUpdateProvider');
  }
  return context;
};

export default VersionUpdateContext;
